import { Organization } from "@/modules/organizations/types/organization.type";

export enum UserStatus {
  ALL = "all",
  ACTIVE = "active",
  INACTIVE = "inactive",
  LOCKED = "deleted",
}

export enum UserType {
  ADMIN = "admin",
  USER = "user",
  AGENCY = "agency",
 }

export interface User {
  id: string;
  fullName: string;
  email: string;
  phone?: string;
  password?: string;
  userPermission: UserPermission[];
  devices: string[];
  rooms: string[];
  type?: UserType;
  status?: UserStatus;
  lastActive?: string;
  roomName?: string;
  roomAddress?: string;
  createdAt: string;
  updatedAt: string;
  devicesList: Device[];
  roomsList: Room[];
  organizationId?: string;
  organization?: Partial<Organization>;
  UserRoomPermission: UserRoomPermission[];
}
export interface Device {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}
export interface Room {
  id: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}
export interface UserPermission {
  permission: Permission;
}
export interface UserRoomPermission {
  roomMeeting: Partial<Room>;  
}
export interface Permission {
  id: string;
  code: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}
export interface CreateUserPayload {
  fullName: string;
  email: string;
  phone?: string;
  password: string;
  permissionIds?: string[];
  devices?: string[];
  rooms?: string[];
  status: UserStatus;
  type?: UserType;
  organizationId?: string;
}

export interface UpdateUserPayload extends Partial<CreateUserPayload> {
  id: string;
}

export interface UserResponse {
  users: User[];
  total: number;
  page: number;
  limit: number;
}

export interface UserFilter {
  page?: number;
  pageSize?: number;
  fullName?: string;
  keyword?: string;
  email?: string;
  status?: UserStatus;
}

export interface Permission {
  id: string;
  code: string;
  name: string;
  description: string;
  createdAt: string;
  updatedAt: string;
}
